import React from "react";
import { connect } from "react-redux";
import NumsDoss from "../NumsDoss";
import { fetchRJ, newRjValue } from "../../redux/actions/rjActions";

class RJMenu extends React.Component {
  async componentDidMount() {
    const { rj, rjValue, dossierValue, dispatch } = this.props;

    if ((!rj?.length || !rjValue) && dossierValue) {
      await dispatch(fetchRJ(dossierValue));
    }
  }

  async componentDidUpdate(prevProps) {
    const { dossierValue, rj, rjValue, dispatch } = this.props;

    if (dossierValue !== prevProps.dossierValue && dossierValue) {
      await dispatch(fetchRJ(dossierValue));
      return;
    }

    if (rj !== prevProps.rj && rj?.length && !rjValue) {
      const lastRj = rj[rj.length - 1];
      await dispatch(newRjValue(lastRj));
      return;
    }

    if (JSON.stringify(rjValue) !== JSON.stringify(prevProps.rjValue)) {
      const matchedRj = rj?.find(item => item.numero === rjValue?.numero);
      if (matchedRj) await dispatch(newRjValue(matchedRj));
    }
  }

  handleRjChange = async (event) => {
    const { dispatch } = this.props;
    const newValue = JSON.parse(event.target.value);
    await dispatch(newRjValue(newValue));
  };

  render() {
    const { rj = [], rjValue, advancement, handleResetValueArray } = this.props;
    const pourcentages = [0, 10, 20, 30, 45, 50, 60, 75, 85, 100];
    const isDisabled = handleResetValueArray === "";

    return (
      <div className="rjmenu">
        <NumsDoss />

        <div className="numero">
          <label>Numéro du Registre Journal :</label>
          <select
            onChange={this.handleRjChange}
            value={JSON.stringify(rjValue || {})}
          >
            {rj.map((item, index) => (
              <option value={JSON.stringify(item)} key={index}>
                {item.numero}
              </option>
            ))}
          </select>
        </div>

        <div className="advancement">
          <label>Avancement :</label>
          <select
            name="avancement"
            value={advancement || ""}
            onChange={
              typeof handleResetValueArray === "function"
                ? handleResetValueArray
                : undefined
            }
            disabled={isDisabled}
          >
            {pourcentages.map((val) => (
              <option value={val} key={val}>
                {val}
              </option>
            ))}
          </select>
          <label> % </label>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  vic: state.vic.items,
  rj: state.rj.items,
  rjValue: state.rj.rjValue,
  photos: state.rj.photos,
  dossierValue: state.devis.dossierValue,
});

export default connect(mapStateToProps)(RJMenu);
